import { memo, useCallback } from "react";
import { AiEmailSuggestions } from "./ai-email-suggestions";

interface AiEmailPreviewSuggestionsProps {
  emailPreview: string;
  subjectLine?: string;
  onSuggestionClick: (suggestion: string) => void;
  getAiEmailPreviewSuggestions: (
    params: { text: string; tone?: string; subjectLine?: string },
    options?: { signal?: AbortSignal },
  ) => Promise<{ text: string; tone: string }[]>;
}

export const AiEmailPreviewSuggestions = memo(
  function AiEmailPreviewSuggestions(props: AiEmailPreviewSuggestionsProps) {
    const {
      emailPreview,
      subjectLine,
      onSuggestionClick,
      getAiEmailPreviewSuggestions,
    } = props;

    const fetchSuggestions = useCallback(
      (
        { text, tone }: { text: string; tone?: string },
        options: { signal: AbortSignal },
      ) => getAiEmailPreviewSuggestions({ text, tone, subjectLine }, options),
      [getAiEmailPreviewSuggestions, subjectLine],
    );

    return (
      <AiEmailSuggestions
        fetchSuggestions={fetchSuggestions}
        logLabel="AI Preview Suggestions"
        onSuggestionClick={onSuggestionClick}
        text={emailPreview}
        title="Preview line suggestions"
      />
    );
  },
);
